import {ImportResult} from "../types.ts";

interface ImportResultPanelProps {
    result: ImportResult;
}

export function ImportResultPanel({result}: ImportResultPanelProps) {
    const failures = result.outcomes.filter((outcome) => outcome.status === "failed");

    return (
        <div className="space-y-4">
            <div className="grid grid-cols-2 gap-4 sm:grid-cols-4">
                <Stat label="Boekingen aangemaakt" value={result.bookingsCreated} tone="good"/>
                <Stat label="Boekingen mislukt" value={result.bookingsFailed} tone="bad"/>
                <Stat label="Bedrijfsmiddelen aangemaakt" value={result.assetsCreated} tone="good"/>
                <Stat label="Bedrijfsmiddelen mislukt" value={result.assetsFailed} tone="bad"/>
            </div>

            {failures.length > 0 && (
                <div className="border border-red-200 bg-red-50 rounded-lg p-4">
                    <h3 className="font-medium text-red-800 mb-2">Mislukt</h3>
                    <ul className="text-sm text-red-700 list-disc list-inside space-y-1">
                        {failures.map((outcome, index) => (
                            <li key={index}>
                                {outcome.label}: {outcome.detail ?? "onbekende fout"}
                            </li>
                        ))}
                    </ul>
                </div>
            )}
        </div>
    );
}

function Stat({label, value, tone}: {label: string; value: number; tone: "good" | "bad"}) {
    const valueColor = value === 0 ? "text-gray-900" : tone === "good" ? "text-green-600" : "text-red-600";
    return (
        <div className="border border-gray-200 rounded-lg p-4">
            <div className={`text-2xl font-semibold ${valueColor}`}>{value}</div>
            <div className="text-xs text-gray-500 mt-1">{label}</div>
        </div>
    );
}
